export default [
  'transport@foodforjoe.com',
  'lucia.farragatao@foodforjoe.es',
  'albane@foodforjoe.es',
  'dana@foodforjoe.es',
  'data@foodforjoe.com',
  'adriana.molvinger@foodforjoe.es',
  'diego@foodforjoe.es',
  'daniel.garrido@foodforjoe.es',
  'jonathan@foodforjoe.com',
  'daniel@wedo-solutions.com',
  'office@wedo-solutions.com',
];
